import { setDlSubmitWithLabel } from './tracking';
export { setzeTrackingTag };

class PasswortAmpel extends HTMLElement {
    connectedCallback() {
        this.initDisableSubmitButton();
        this.initPasswortAmpel();
    }

    initDisableSubmitButton() {
        const submitButton = document.querySelector(".passwort-submit");
        submitButton.setAttribute("disabled", "");
    }

    initPasswortAmpel() {
        const inputPasswort = document.querySelector(".passwort-ampel-input");
        const passwortAmpel = document.querySelector(".passwort-ampel");

        inputPasswort.addEventListener("focus", (event) => {
            passwortAmpel.classList.remove("hide");
        })

        inputPasswort.addEventListener("input", event => {
            this.pruefeUpperLowerCase(event.target.value);
            this.pruefePasswortlaenge(event.target.value);
            this.pruefeEnthaeltZahl(event.target.value);
            this.pruefeEnthaeltSonderzeichen(event.target.value);
            this.pruefeAnzahlAnforderungen();
        })
    }

    pruefePasswortlaenge(passwort) {
        const anforderung1 = this.querySelector(".anforderung1");

        this.haekchenKreuzchenSetzen(anforderung1, passwort.length >= 8 && passwort.length <= 128);
    }

    pruefeUpperLowerCase(passwort) {
        const anforderung2 = this.querySelector(".anforderung2");
        let regexUpper = /[A-ZÄÁÀÂÃÅĀÆĆČÇÈÉÊËĒĘĖÌÍÎÏĮĪÑŃÖÒÓÔÕŌØŒßŚŜÜÙÚÛŪÝŸ]/;
        let regexLower = /[a-zäàáâãåāæćçčèéêëęėēìíîïīįñńöòóôōõœøšśüùúûūýÿ]/;

        this.haekchenKreuzchenSetzen(anforderung2, passwort.match(regexLower) !== null && passwort.match(regexUpper) !== null);
    }

    pruefeEnthaeltZahl(passwort) {
        const anforderung3 = this.querySelector(".anforderung3");
        let regexZahl = /[0-9]/;

        this.haekchenKreuzchenSetzen(anforderung3, passwort.match(regexZahl) !== null);
    }

    pruefeEnthaeltSonderzeichen(passwort) {
        const anforderung4 = this.querySelector(".anforderung4");
        let regexSonderzeichen = /[#£€$%^&*()!¡?¿><\[\]=+|\\/{}:;'\"@\~§¥·°\-\_,.@?]/;

        this.haekchenKreuzchenSetzen(anforderung4, passwort.match(regexSonderzeichen) !== null);
    }

    haekchenKreuzchenSetzen(anforderung, bedingung) {
        if (bedingung) {
            anforderung.classList.remove("kreuz");
            anforderung.classList.add("haekchen");
        } else {
            anforderung.classList.remove("haekchen");
            anforderung.classList.add("kreuz");
        }
    }

    pruefeAnzahlAnforderungen() {
        let haekchenListe = this.querySelectorAll(".haekchen");
        const pflichtBedingungErfuellt = this.querySelector(".anforderung1").classList.contains("haekchen");
        const passwortStaerkeText = this.querySelector(".passwort-text");
        const passwortBalken = this.querySelector(".passwort-balken");
        const submitButton = document.querySelector(".passwort-submit");

        if (haekchenListe.length === 0 || !pflichtBedingungErfuellt) {
            passwortStaerkeText.setAttribute("data-color", "rot");
            passwortBalken.setAttribute("data-color", "rot");

            submitButton.setAttribute("disabled", "");
        }

        if (pflichtBedingungErfuellt && haekchenListe.length <= 3) {
            passwortStaerkeText.setAttribute("data-color", "gelb");
            passwortBalken.setAttribute("data-color", "gelb");

            submitButton.removeAttribute("disabled");
        }

        if (haekchenListe.length >= 4) {
            passwortStaerkeText.setAttribute("data-color", "gruen");
            passwortBalken.setAttribute("data-color", "gruen");

            submitButton.removeAttribute("disabled");
        }
    }

}

// Die Funktion darf erst aufgerufen werden, wenn das Formular abgeschickt wird, s. https://gitlab.thalia.de/team-wdd/data-layer/-/tree/master/anleitung#7-submit-form-tracking
function setzeTrackingTag() {
    const passwortStaerkeTexte = document.querySelectorAll(".passwort-text span");
    let aktuellePasswortStaerke;
    for (const passwortStaerke of passwortStaerkeTexte) {
        // angezeigtes Element suchen
        if (window.getComputedStyle(passwortStaerke, null).display !== "none") {
            aktuellePasswortStaerke = passwortStaerke;
        }
    }

    if (aktuellePasswortStaerke) {
        setDlSubmitWithLabel(aktuellePasswortStaerke, `passwort-staerke-${aktuellePasswortStaerke.textContent}`, true);
    }
}

customElements.define('passwort-ampel', PasswortAmpel);